<template>
  <div class='SDAU_style data_box'>
    <div class='treeBox'>
      <div class='left_tree'>
        <div class='treeHeader'>
          资料分组
        </div>
        <el-tree :data="filetreeData" @node-click="filetreeClick" node-key="id" ref="filetree" highlight-current
          :props="defaultProps">
        </el-tree>
      </div>
    </div>
    <div class='dataMsgbox'>
      <div class='data_header'>
        <div style='font-size: 24px;font-family: Source Han Sans SC;font-weight: bold;color: #333333;'>
          资料查看</div>
        <span style="font-size:14px;color:#999999;">
          您的位置：
          <span style='color:#999999;cursor: pointer;' @click="toHome">首页></span>
          <span style="color:#188335">资料查看</span>
        </span>
      </div>
      <div class='sdau_search'>
        <el-form ref="form" :model="formData" label-width="100px" :inline="true">
          <el-row>
            <el-col :span='8'>
              <el-form-item label="附件名称">
                <el-input placeholder="请输入设备名称" v-model="formData.documentName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
              </el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="e_reset">重置 </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData">
        <el-table-column type="index" :index="Nindex" width="55" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="documentName" width="150" label="文件标题" align="center">
        </el-table-column>
        <el-table-column prop="uploadTime" label="上传时间" align="center">
        </el-table-column>
        <el-table-column prop="uploadUserName" label="上传人" align="center">
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="['pdf', 'jpg', 'png'].includes(scope.row.uploadFile.filePath.split('.')[1])" type="text"
              size="small"
              v-Login="() => downLoadorshow(scope.row.uploadFile.filePath, scope.row.uploadFile.fileName, 0)">查看</el-button>
            <el-button type="text" size="small"
              v-Login="() => downLoadorshow(scope.row.uploadFile.filePath, scope.row.uploadFile.fileName, 1)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :pageSizes="pageSizes" :total="total" :page.sync="formData.pageNum"
        :limit.sync="formData.pageSize" @pagination='init' />
    </div>
    <el-dialog :title="'预览'" :visible.sync="showFormDetail" append-to-body center top="10px" :show-close="true"
      @close="showFormDetail = false" :close-on-press-escape="false" class="QMS-dialog QMS-dialog_center"
      :close-on-click-modal="false">
      <iframe style="width: 100%; height: 75vh" :src="pdfURL" frameborder="0" v-if="showFormDetail"></iframe>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showFormDetail = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const { APIURl } = require('@/utils/apiUrl')
import { downloadFileofurl } from '@/api/downLoad/downLoad.js'
export default {
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 5,
        treeId: '',
      },
      pageSizes: [5, 10, 20, 50, 100, 300],
      total: 0,
      showFormDetail: false,
      defaultProps: {
        label: 'nodeName',
        children: 'childList'
      },
      filetreeData: [],
      fileSelectid: '',
      tableData: [],
      imageData: {
        url: []
      },
      pdfURL: ''
    }
  },
  methods: {
    handleQuery() {
      this.formData.pageNum = 1
      this.init()
    },
    toHome() {
      this.$router.push({ path: '/' })
    },
    e_reset() {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
      }
      this.init()
    },
    Nindex(index) {
      const page = this.formData.pageNum
      const pagesize = this.formData.pageSize
      return index + 1 + (page - 1) * pagesize
    },
    init() {
      this.$net('/document/list', 'get', this.formData).then(res => {
        this.tableData = res.data.rows
        this.total = res.data.total
      })
    },
    gettreeData() {
      this.$net('/documentTypeTree/selectTree', 'get').then(res => {
        this.filetreeData = res.data
      })
    },
    filetreeClick() {
      if (this.formData.treeId == '') {
        this.formData.treeId = this.$refs.filetree.getCurrentKey()
      }
      else {
        if (this.formData.treeId == this.$refs.filetree.getCurrentKey()) {
          this.$refs.filetree.setCurrentKey(null);
          this.formData.treeId = ''
        }
        else {
          this.formData.treeId = this.$refs.filetree.getCurrentKey()
        }
      }
      this.init()
    },
    downLoadorshow(url, name, downtype) {
      if (downtype) {
        downloadFileofurl('/' + url, name)
      }
      else {
        if (url.split('.')[1] == 'pdf') {
          this.pdfURL = "/pdfjs/web/viewer.html?file=" + APIURl + '/' + url;
          this.showFormDetail = true
        }
        else {
          this.imageData.url = [APIURl + '/' + url]
          this.$viewerApi({
            images: this.imageData.url
          })
        }
      }
    },
  },
  created() {
    this.gettreeData()
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep.data_box {
  .el-tree-node__label {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #333333;
  }

  margin-top: 32px;
  display: flex;
  justify-content: space-between;

  .treeBox {
    width: 20%;

    .left_tree {
      border: 1px solid #d7dce0;
      opacity: 1;
      margin-bottom: 32px;

      .treeHeader {
        background: #f6f6f6;
        height: 64px;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #333333;
        padding-left: 32px;
        line-height: 64px;
      }
    }
  }

  .dataMsgbox {
    width: 75%;

    .data_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

  }
}

::v-deep .el-table th {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #666666;
}

::v-deep .el-table td {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #333333;
}
</style>